import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Followers } from "@/pages/creator/Dashboard";

export default function CreatorFollowers() {
  const [f, setF] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get("/creator/followers").then((r) => setF(r.data)).catch(() => setErr(true));
  }, []);
  return (
    <div data-testid="creator-followers" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Followers</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">People who follow you for free. Followers are separate from paying members.</p>
      </div>
      {err ? <p className="text-sm text-red-300">Couldn't load followers. Please try again.</p> : f ? <Followers f={f} /> : <p className="text-sm text-[#a7a0af]">Loading…</p>}
    </div>
  );
}
